import {getArea} from '@apps-common/geocorn-sdk/geom/cea';

import {
  acres,
  hectares,
  identity,
  squareFeet,
  squareKilometers,
  squareMiles,
  squareNauticalMiles,
} from './conversions.js';
import formatNumber from './format-number.js';
import {areaUnits} from '@app/constants';

export const conversionMap = {
  [areaUnits.metric.m2]: n => identity(n),
  [areaUnits.metric.km2]: n => squareKilometers(n),
  [areaUnits.metric.ha]: n => hectares(n),
  [areaUnits.usc.ft2]: n => squareFeet(n),
  [areaUnits.usc.mi2]: n => squareMiles(n),
  [areaUnits.usc.ac]: n => acres(n),
  [areaUnits.usc.nmi2]: n => squareNauticalMiles(n),
};

export const localizationMap = {
  [areaUnits.metric.m2]: 'm²',
  [areaUnits.metric.km2]: 'km²',
  [areaUnits.metric.ha]: 'ha',
  [areaUnits.usc.ft2]: 'ft²',
  [areaUnits.usc.mi2]: 'mi²',
  [areaUnits.usc.ac]: 'ac',
  [areaUnits.usc.nmi2]: 'nm²',
};

export const DEFAULT_AREA_FORMAT = '0,0.[000]';

export const formatArea = (
  squareMeters,
  unit = areaUnits.metric.m2,
  format = DEFAULT_AREA_FORMAT
) => {
  if (!conversionMap[unit]) {
    return '';
  }
  return formatNumber(squareMeters, conversionMap[unit], format);
};

export const formatPolygonArea = (
  polygon,
  unit = areaUnits.metric.m2,
  format = DEFAULT_AREA_FORMAT
) => {
  if (!conversionMap[unit]) {
    return '';
  }
  const squareMeters = getArea(polygon);
  return formatArea(squareMeters, unit, format);
};
